/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as StoreLayoutRouteImport } from './routes/$store/_layout'
import { Route as AuthAuthLayoutRouteImport } from './routes/_auth/_auth-layout'
import { Route as StoreLayoutIndexRouteImport } from './routes/$store/_layout/index'
import { Route as StoreLayoutCategoriesRouteImport } from './routes/$store/_layout/categories'
import { Route as StoreLayoutCouponsRouteImport } from './routes/$store/_layout/coupons'
import { Route as StoreLayoutImagesRouteImport } from './routes/$store/_layout/images'
import { Route as StoreLayoutOrdersRouteImport } from './routes/$store/_layout/orders'
import { Route as StoreLayoutProductsRouteImport } from './routes/$store/_layout/products'
import { Route as StoreLayoutPromotionsRouteImport } from './routes/$store/_layout/promotions'
import { Route as StoreLayoutSiteCustomizationRouteImport } from './routes/$store/_layout/site-customization'
import { Route as StoreLayoutTagsRouteImport } from './routes/$store/_layout/tags'
import { Route as AuthAuthLayoutForgotPasswordRouteImport } from './routes/_auth/_auth-layout/forgot-password'
import { Route as AuthAuthLayoutResetPasswordRouteImport } from './routes/_auth/_auth-layout/reset-password'
import { Route as AuthAuthLayoutSigninRouteImport } from './routes/_auth/_auth-layout/signin'
import { Route as StoreLayoutAdminFeatureAnnouncementsRouteImport } from './routes/$store/_layout/admin_.feature-announcements'
import { Route as StoreLayoutAdminPaymentMethodsRouteImport } from './routes/$store/_layout/admin_.payment-methods'
import { Route as StoreLayoutAdminShippingMethodsRouteImport } from './routes/$store/_layout/admin_.shipping-methods'
import { Route as StoreLayoutProductsAddRouteImport } from './routes/$store/_layout/products_.add'
import { Route as StoreLayoutSettingsApiRouteImport } from './routes/$store/_layout/settings_.api'
import { Route as StoreLayoutSettingsGeneralRouteImport } from './routes/$store/_layout/settings_.general'
import { Route as StoreLayoutSettingsPaymentRouteImport } from './routes/$store/_layout/settings_.payment'
import { Route as StoreLayoutSettingsSeoRouteImport } from './routes/$store/_layout/settings_.seo'
import { Route as StoreLayoutSettingsShippingRouteImport } from './routes/$store/_layout/settings_.shipping'
import { Route as StoreLayoutSettingsTeamRouteImport } from './routes/$store/_layout/settings_.team'
import { Route as StoreLayoutAdminFeatureAnnouncementsNewRouteImport } from './routes/$store/_layout/admin_.feature-announcements_.new'

const StoreLayoutRoute = StoreLayoutRouteImport.update({
  id: '/$store/_layout',
  path: '/$store',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthAuthLayoutRoute = AuthAuthLayoutRouteImport.update({
  id: '/_auth/_auth-layout',
  getParentRoute: () => rootRouteImport,
} as any)
const StoreLayoutIndexRoute = StoreLayoutIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => StoreLayoutRoute,
} as any)
const StoreLayoutCategoriesRoute = StoreLayoutCategoriesRouteImport.update({
  id: '/categories',
  path: '/categories',
  getParentRoute: () => StoreLayoutRoute,
} as any)
const StoreLayoutCouponsRoute = StoreLayoutCouponsRouteImport.update({
  id: '/coupons',
  path: '/coupons',
  getParentRoute: () => StoreLayoutRoute,
} as any)
const StoreLayoutImagesRoute = StoreLayoutImagesRouteImport.update({
  id: '/images',
  path: '/images',
  getParentRoute: () => StoreLayoutRoute,
} as any)
const StoreLayoutOrdersRoute = StoreLayoutOrdersRouteImport.update({
  id: '/orders',
  path: '/orders',
  getParentRoute: () => StoreLayoutRoute,
} as any)
const StoreLayoutProductsRoute = StoreLayoutProductsRouteImport.update({
  id: '/products',
  path: '/products',
  getParentRoute: () => StoreLayoutRoute,
} as any)
const StoreLayoutPromotionsRoute = StoreLayoutPromotionsRouteImport.update({
  id: '/promotions',
  path: '/promotions',
  getParentRoute: () => StoreLayoutRoute,
} as any)
const StoreLayoutSiteCustomizationRoute =
  StoreLayoutSiteCustomizationRouteImport.update({
    id: '/site-customization',
    path: '/site-customization',
    getParentRoute: () => StoreLayoutRoute,
  } as any)
const StoreLayoutTagsRoute = StoreLayoutTagsRouteImport.update({
  id: '/tags',
  path: '/tags',
  getParentRoute: () => StoreLayoutRoute,
} as any)
const AuthAuthLayoutForgotPasswordRoute =
  AuthAuthLayoutForgotPasswordRouteImport.update({
    id: '/forgot-password',
    path: '/forgot-password',
    getParentRoute: () => AuthAuthLayoutRoute,
  } as any)
const AuthAuthLayoutResetPasswordRoute =
  AuthAuthLayoutResetPasswordRouteImport.update({
    id: '/reset-password',
    path: '/reset-password',
    getParentRoute: () => AuthAuthLayoutRoute,
  } as any)
const AuthAuthLayoutSigninRoute = AuthAuthLayoutSigninRouteImport.update({
  id: '/signin',
  path: '/signin',
  getParentRoute: () => AuthAuthLayoutRoute,
} as any)
const StoreLayoutAdminFeatureAnnouncementsRoute =
  StoreLayoutAdminFeatureAnnouncementsRouteImport.update({
    id: '/admin_/feature-announcements',
    path: '/admin/feature-announcements',
    getParentRoute: () => StoreLayoutRoute,
  } as any)
const StoreLayoutAdminPaymentMethodsRoute =
  StoreLayoutAdminPaymentMethodsRouteImport.update({
    id: '/admin_/payment-methods',
    path: '/admin/payment-methods',
    getParentRoute: () => StoreLayoutRoute,
  } as any)
const StoreLayoutAdminShippingMethodsRoute =
  StoreLayoutAdminShippingMethodsRouteImport.update({
    id: '/admin_/shipping-methods',
    path: '/admin/shipping-methods',
    getParentRoute: () => StoreLayoutRoute,
  } as any)
const StoreLayoutProductsAddRoute = StoreLayoutProductsAddRouteImport.update({
  id: '/products_/add',
  path: '/products/add',
  getParentRoute: () => StoreLayoutRoute,
} as any)
const StoreLayoutSettingsApiRoute = StoreLayoutSettingsApiRouteImport.update({
  id: '/settings_/api',
  path: '/settings/api',
  getParentRoute: () => StoreLayoutRoute,
} as any)
const StoreLayoutSettingsGeneralRoute =
  StoreLayoutSettingsGeneralRouteImport.update({
    id: '/settings_/general',
    path: '/settings/general',
    getParentRoute: () => StoreLayoutRoute,
  } as any)
const StoreLayoutSettingsPaymentRoute =
  StoreLayoutSettingsPaymentRouteImport.update({
    id: '/settings_/payment',
    path: '/settings/payment',
    getParentRoute: () => StoreLayoutRoute,
  } as any)
const StoreLayoutSettingsSeoRoute = StoreLayoutSettingsSeoRouteImport.update({
  id: '/settings_/seo',
  path: '/settings/seo',
  getParentRoute: () => StoreLayoutRoute,
} as any)
const StoreLayoutSettingsShippingRoute =
  StoreLayoutSettingsShippingRouteImport.update({
    id: '/settings_/shipping',
    path: '/settings/shipping',
    getParentRoute: () => StoreLayoutRoute,
  } as any)
const StoreLayoutSettingsTeamRoute = StoreLayoutSettingsTeamRouteImport.update({
  id: '/settings_/team',
  path: '/settings/team',
  getParentRoute: () => StoreLayoutRoute,
} as any)
const StoreLayoutAdminFeatureAnnouncementsNewRoute =
  StoreLayoutAdminFeatureAnnouncementsNewRouteImport.update({
    id: '/admin_/feature-announcements_/new',
    path: '/admin/feature-announcements/new',
    getParentRoute: () => StoreLayoutRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/$store': typeof StoreLayoutRouteWithChildren
  '/': typeof AuthAuthLayoutRouteWithChildren
  '/$store/categories': typeof StoreLayoutCategoriesRoute
  '/$store/coupons': typeof StoreLayoutCouponsRoute
  '/$store/images': typeof StoreLayoutImagesRoute
  '/$store/orders': typeof StoreLayoutOrdersRoute
  '/$store/products': typeof StoreLayoutProductsRoute
  '/$store/promotions': typeof StoreLayoutPromotionsRoute
  '/$store/site-customization': typeof StoreLayoutSiteCustomizationRoute
  '/$store/tags': typeof StoreLayoutTagsRoute
  '/forgot-password': typeof AuthAuthLayoutForgotPasswordRoute
  '/reset-password': typeof AuthAuthLayoutResetPasswordRoute
  '/signin': typeof AuthAuthLayoutSigninRoute
  '/$store/': typeof StoreLayoutIndexRoute
  '/$store/admin/feature-announcements': typeof StoreLayoutAdminFeatureAnnouncementsRoute
  '/$store/admin/payment-methods': typeof StoreLayoutAdminPaymentMethodsRoute
  '/$store/admin/shipping-methods': typeof StoreLayoutAdminShippingMethodsRoute
  '/$store/products/add': typeof StoreLayoutProductsAddRoute
  '/$store/settings/api': typeof StoreLayoutSettingsApiRoute
  '/$store/settings/general': typeof StoreLayoutSettingsGeneralRoute
  '/$store/settings/payment': typeof StoreLayoutSettingsPaymentRoute
  '/$store/settings/seo': typeof StoreLayoutSettingsSeoRoute
  '/$store/settings/shipping': typeof StoreLayoutSettingsShippingRoute
  '/$store/settings/team': typeof StoreLayoutSettingsTeamRoute
  '/$store/admin/feature-announcements/new': typeof StoreLayoutAdminFeatureAnnouncementsNewRoute
}
export interface FileRoutesByTo {
  '/': typeof AuthAuthLayoutRouteWithChildren
  '/$store/categories': typeof StoreLayoutCategoriesRoute
  '/$store/coupons': typeof StoreLayoutCouponsRoute
  '/$store/images': typeof StoreLayoutImagesRoute
  '/$store/orders': typeof StoreLayoutOrdersRoute
  '/$store/products': typeof StoreLayoutProductsRoute
  '/$store/promotions': typeof StoreLayoutPromotionsRoute
  '/$store/site-customization': typeof StoreLayoutSiteCustomizationRoute
  '/$store/tags': typeof StoreLayoutTagsRoute
  '/forgot-password': typeof AuthAuthLayoutForgotPasswordRoute
  '/reset-password': typeof AuthAuthLayoutResetPasswordRoute
  '/signin': typeof AuthAuthLayoutSigninRoute
  '/$store': typeof StoreLayoutIndexRoute
  '/$store/admin/feature-announcements': typeof StoreLayoutAdminFeatureAnnouncementsRoute
  '/$store/admin/payment-methods': typeof StoreLayoutAdminPaymentMethodsRoute
  '/$store/admin/shipping-methods': typeof StoreLayoutAdminShippingMethodsRoute
  '/$store/products/add': typeof StoreLayoutProductsAddRoute
  '/$store/settings/api': typeof StoreLayoutSettingsApiRoute
  '/$store/settings/general': typeof StoreLayoutSettingsGeneralRoute
  '/$store/settings/payment': typeof StoreLayoutSettingsPaymentRoute
  '/$store/settings/seo': typeof StoreLayoutSettingsSeoRoute
  '/$store/settings/shipping': typeof StoreLayoutSettingsShippingRoute
  '/$store/settings/team': typeof StoreLayoutSettingsTeamRoute
  '/$store/admin/feature-announcements/new': typeof StoreLayoutAdminFeatureAnnouncementsNewRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/$store/_layout': typeof StoreLayoutRouteWithChildren
  '/_auth/_auth-layout': typeof AuthAuthLayoutRouteWithChildren
  '/$store/_layout/categories': typeof StoreLayoutCategoriesRoute
  '/$store/_layout/coupons': typeof StoreLayoutCouponsRoute
  '/$store/_layout/images': typeof StoreLayoutImagesRoute
  '/$store/_layout/orders': typeof StoreLayoutOrdersRoute
  '/$store/_layout/products': typeof StoreLayoutProductsRoute
  '/$store/_layout/promotions': typeof StoreLayoutPromotionsRoute
  '/$store/_layout/site-customization': typeof StoreLayoutSiteCustomizationRoute
  '/$store/_layout/tags': typeof StoreLayoutTagsRoute
  '/_auth/_auth-layout/forgot-password': typeof AuthAuthLayoutForgotPasswordRoute
  '/_auth/_auth-layout/reset-password': typeof AuthAuthLayoutResetPasswordRoute
  '/_auth/_auth-layout/signin': typeof AuthAuthLayoutSigninRoute
  '/$store/_layout/': typeof StoreLayoutIndexRoute
  '/$store/_layout/admin_/feature-announcements': typeof StoreLayoutAdminFeatureAnnouncementsRoute
  '/$store/_layout/admin_/payment-methods': typeof StoreLayoutAdminPaymentMethodsRoute
  '/$store/_layout/admin_/shipping-methods': typeof StoreLayoutAdminShippingMethodsRoute
  '/$store/_layout/products_/add': typeof StoreLayoutProductsAddRoute
  '/$store/_layout/settings_/api': typeof StoreLayoutSettingsApiRoute
  '/$store/_layout/settings_/general': typeof StoreLayoutSettingsGeneralRoute
  '/$store/_layout/settings_/payment': typeof StoreLayoutSettingsPaymentRoute
  '/$store/_layout/settings_/seo': typeof StoreLayoutSettingsSeoRoute
  '/$store/_layout/settings_/shipping': typeof StoreLayoutSettingsShippingRoute
  '/$store/_layout/settings_/team': typeof StoreLayoutSettingsTeamRoute
  '/$store/_layout/admin_/feature-announcements_/new': typeof StoreLayoutAdminFeatureAnnouncementsNewRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/$store'
    | '/'
    | '/$store/categories'
    | '/$store/coupons'
    | '/$store/images'
    | '/$store/orders'
    | '/$store/products'
    | '/$store/promotions'
    | '/$store/site-customization'
    | '/$store/tags'
    | '/forgot-password'
    | '/reset-password'
    | '/signin'
    | '/$store/'
    | '/$store/admin/feature-announcements'
    | '/$store/admin/payment-methods'
    | '/$store/admin/shipping-methods'
    | '/$store/products/add'
    | '/$store/settings/api'
    | '/$store/settings/general'
    | '/$store/settings/payment'
    | '/$store/settings/seo'
    | '/$store/settings/shipping'
    | '/$store/settings/team'
    | '/$store/admin/feature-announcements/new'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$store/categories'
    | '/$store/coupons'
    | '/$store/images'
    | '/$store/orders'
    | '/$store/products'
    | '/$store/promotions'
    | '/$store/site-customization'
    | '/$store/tags'
    | '/forgot-password'
    | '/reset-password'
    | '/signin'
    | '/$store'
    | '/$store/admin/feature-announcements'
    | '/$store/admin/payment-methods'
    | '/$store/admin/shipping-methods'
    | '/$store/products/add'
    | '/$store/settings/api'
    | '/$store/settings/general'
    | '/$store/settings/payment'
    | '/$store/settings/seo'
    | '/$store/settings/shipping'
    | '/$store/settings/team'
    | '/$store/admin/feature-announcements/new'
  id:
    | '__root__'
    | '/$store/_layout'
    | '/_auth/_auth-layout'
    | '/$store/_layout/categories'
    | '/$store/_layout/coupons'
    | '/$store/_layout/images'
    | '/$store/_layout/orders'
    | '/$store/_layout/products'
    | '/$store/_layout/promotions'
    | '/$store/_layout/site-customization'
    | '/$store/_layout/tags'
    | '/_auth/_auth-layout/forgot-password'
    | '/_auth/_auth-layout/reset-password'
    | '/_auth/_auth-layout/signin'
    | '/$store/_layout/'
    | '/$store/_layout/admin_/feature-announcements'
    | '/$store/_layout/admin_/payment-methods'
    | '/$store/_layout/admin_/shipping-methods'
    | '/$store/_layout/products_/add'
    | '/$store/_layout/settings_/api'
    | '/$store/_layout/settings_/general'
    | '/$store/_layout/settings_/payment'
    | '/$store/_layout/settings_/seo'
    | '/$store/_layout/settings_/shipping'
    | '/$store/_layout/settings_/team'
    | '/$store/_layout/admin_/feature-announcements_/new'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  StoreLayoutRoute: typeof StoreLayoutRouteWithChildren
  AuthAuthLayoutRoute: typeof AuthAuthLayoutRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/$store/_layout': {
      id: '/$store/_layout'
      path: '/$store'
      fullPath: '/$store'
      preLoaderRoute: typeof StoreLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/_auth-layout': {
      id: '/_auth/_auth-layout'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthAuthLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$store/_layout/': {
      id: '/$store/_layout/'
      path: '/'
      fullPath: '/$store/'
      preLoaderRoute: typeof StoreLayoutIndexRouteImport
      parentRoute: typeof StoreLayoutRoute
    }
    '/$store/_layout/categories': {
      id: '/$store/_layout/categories'
      path: '/categories'
      fullPath: '/$store/categories'
      preLoaderRoute: typeof StoreLayoutCategoriesRouteImport
      parentRoute: typeof StoreLayoutRoute
    }
    '/$store/_layout/coupons': {
      id: '/$store/_layout/coupons'
      path: '/coupons'
      fullPath: '/$store/coupons'
      preLoaderRoute: typeof StoreLayoutCouponsRouteImport
      parentRoute: typeof StoreLayoutRoute
    }
    '/$store/_layout/images': {
      id: '/$store/_layout/images'
      path: '/images'
      fullPath: '/$store/images'
      preLoaderRoute: typeof StoreLayoutImagesRouteImport
      parentRoute: typeof StoreLayoutRoute
    }
    '/$store/_layout/orders': {
      id: '/$store/_layout/orders'
      path: '/orders'
      fullPath: '/$store/orders'
      preLoaderRoute: typeof StoreLayoutOrdersRouteImport
      parentRoute: typeof StoreLayoutRoute
    }
    '/$store/_layout/products': {
      id: '/$store/_layout/products'
      path: '/products'
      fullPath: '/$store/products'
      preLoaderRoute: typeof StoreLayoutProductsRouteImport
      parentRoute: typeof StoreLayoutRoute
    }
    '/$store/_layout/promotions': {
      id: '/$store/_layout/promotions'
      path: '/promotions'
      fullPath: '/$store/promotions'
      preLoaderRoute: typeof StoreLayoutPromotionsRouteImport
      parentRoute: typeof StoreLayoutRoute
    }
    '/$store/_layout/site-customization': {
      id: '/$store/_layout/site-customization'
      path: '/site-customization'
      fullPath: '/$store/site-customization'
      preLoaderRoute: typeof StoreLayoutSiteCustomizationRouteImport
      parentRoute: typeof StoreLayoutRoute
    }
    '/$store/_layout/tags': {
      id: '/$store/_layout/tags'
      path: '/tags'
      fullPath: '/$store/tags'
      preLoaderRoute: typeof StoreLayoutTagsRouteImport
      parentRoute: typeof StoreLayoutRoute
    }
    '/_auth/_auth-layout/forgot-password': {
      id: '/_auth/_auth-layout/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof AuthAuthLayoutForgotPasswordRouteImport
      parentRoute: typeof AuthAuthLayoutRoute
    }
    '/_auth/_auth-layout/reset-password': {
      id: '/_auth/_auth-layout/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof AuthAuthLayoutResetPasswordRouteImport
      parentRoute: typeof AuthAuthLayoutRoute
    }
    '/_auth/_auth-layout/signin': {
      id: '/_auth/_auth-layout/signin'
      path: '/signin'
      fullPath: '/signin'
      preLoaderRoute: typeof AuthAuthLayoutSigninRouteImport
      parentRoute: typeof AuthAuthLayoutRoute
    }
    '/$store/_layout/admin_/feature-announcements': {
      id: '/$store/_layout/admin_/feature-announcements'
      path: '/admin/feature-announcements'
      fullPath: '/$store/admin/feature-announcements'
      preLoaderRoute: typeof StoreLayoutAdminFeatureAnnouncementsRouteImport
      parentRoute: typeof StoreLayoutRoute
    }
    '/$store/_layout/admin_/payment-methods': {
      id: '/$store/_layout/admin_/payment-methods'
      path: '/admin/payment-methods'
      fullPath: '/$store/admin/payment-methods'
      preLoaderRoute: typeof StoreLayoutAdminPaymentMethodsRouteImport
      parentRoute: typeof StoreLayoutRoute
    }
    '/$store/_layout/admin_/shipping-methods': {
      id: '/$store/_layout/admin_/shipping-methods'
      path: '/admin/shipping-methods'
      fullPath: '/$store/admin/shipping-methods'
      preLoaderRoute: typeof StoreLayoutAdminShippingMethodsRouteImport
      parentRoute: typeof StoreLayoutRoute
    }
    '/$store/_layout/products_/add': {
      id: '/$store/_layout/products_/add'
      path: '/products/add'
      fullPath: '/$store/products/add'
      preLoaderRoute: typeof StoreLayoutProductsAddRouteImport
      parentRoute: typeof StoreLayoutRoute
    }
    '/$store/_layout/settings_/api': {
      id: '/$store/_layout/settings_/api'
      path: '/settings/api'
      fullPath: '/$store/settings/api'
      preLoaderRoute: typeof StoreLayoutSettingsApiRouteImport
      parentRoute: typeof StoreLayoutRoute
    }
    '/$store/_layout/settings_/general': {
      id: '/$store/_layout/settings_/general'
      path: '/settings/general'
      fullPath: '/$store/settings/general'
      preLoaderRoute: typeof StoreLayoutSettingsGeneralRouteImport
      parentRoute: typeof StoreLayoutRoute
    }
    '/$store/_layout/settings_/payment': {
      id: '/$store/_layout/settings_/payment'
      path: '/settings/payment'
      fullPath: '/$store/settings/payment'
      preLoaderRoute: typeof StoreLayoutSettingsPaymentRouteImport
      parentRoute: typeof StoreLayoutRoute
    }
    '/$store/_layout/settings_/seo': {
      id: '/$store/_layout/settings_/seo'
      path: '/settings/seo'
      fullPath: '/$store/settings/seo'
      preLoaderRoute: typeof StoreLayoutSettingsSeoRouteImport
      parentRoute: typeof StoreLayoutRoute
    }
    '/$store/_layout/settings_/shipping': {
      id: '/$store/_layout/settings_/shipping'
      path: '/settings/shipping'
      fullPath: '/$store/settings/shipping'
      preLoaderRoute: typeof StoreLayoutSettingsShippingRouteImport
      parentRoute: typeof StoreLayoutRoute
    }
    '/$store/_layout/settings_/team': {
      id: '/$store/_layout/settings_/team'
      path: '/settings/team'
      fullPath: '/$store/settings/team'
      preLoaderRoute: typeof StoreLayoutSettingsTeamRouteImport
      parentRoute: typeof StoreLayoutRoute
    }
    '/$store/_layout/admin_/feature-announcements_/new': {
      id: '/$store/_layout/admin_/feature-announcements_/new'
      path: '/admin/feature-announcements/new'
      fullPath: '/$store/admin/feature-announcements/new'
      preLoaderRoute: typeof StoreLayoutAdminFeatureAnnouncementsNewRouteImport
      parentRoute: typeof StoreLayoutRoute
    }
  }
}

interface StoreLayoutRouteChildren {
  StoreLayoutCategoriesRoute: typeof StoreLayoutCategoriesRoute
  StoreLayoutCouponsRoute: typeof StoreLayoutCouponsRoute
  StoreLayoutImagesRoute: typeof StoreLayoutImagesRoute
  StoreLayoutOrdersRoute: typeof StoreLayoutOrdersRoute
  StoreLayoutProductsRoute: typeof StoreLayoutProductsRoute
  StoreLayoutPromotionsRoute: typeof StoreLayoutPromotionsRoute
  StoreLayoutSiteCustomizationRoute: typeof StoreLayoutSiteCustomizationRoute
  StoreLayoutTagsRoute: typeof StoreLayoutTagsRoute
  StoreLayoutIndexRoute: typeof StoreLayoutIndexRoute
  StoreLayoutAdminFeatureAnnouncementsRoute: typeof StoreLayoutAdminFeatureAnnouncementsRoute
  StoreLayoutAdminPaymentMethodsRoute: typeof StoreLayoutAdminPaymentMethodsRoute
  StoreLayoutAdminShippingMethodsRoute: typeof StoreLayoutAdminShippingMethodsRoute
  StoreLayoutProductsAddRoute: typeof StoreLayoutProductsAddRoute
  StoreLayoutSettingsApiRoute: typeof StoreLayoutSettingsApiRoute
  StoreLayoutSettingsGeneralRoute: typeof StoreLayoutSettingsGeneralRoute
  StoreLayoutSettingsPaymentRoute: typeof StoreLayoutSettingsPaymentRoute
  StoreLayoutSettingsSeoRoute: typeof StoreLayoutSettingsSeoRoute
  StoreLayoutSettingsShippingRoute: typeof StoreLayoutSettingsShippingRoute
  StoreLayoutSettingsTeamRoute: typeof StoreLayoutSettingsTeamRoute
  StoreLayoutAdminFeatureAnnouncementsNewRoute: typeof StoreLayoutAdminFeatureAnnouncementsNewRoute
}

const StoreLayoutRouteChildren: StoreLayoutRouteChildren = {
  StoreLayoutCategoriesRoute: StoreLayoutCategoriesRoute,
  StoreLayoutCouponsRoute: StoreLayoutCouponsRoute,
  StoreLayoutImagesRoute: StoreLayoutImagesRoute,
  StoreLayoutOrdersRoute: StoreLayoutOrdersRoute,
  StoreLayoutProductsRoute: StoreLayoutProductsRoute,
  StoreLayoutPromotionsRoute: StoreLayoutPromotionsRoute,
  StoreLayoutSiteCustomizationRoute: StoreLayoutSiteCustomizationRoute,
  StoreLayoutTagsRoute: StoreLayoutTagsRoute,
  StoreLayoutIndexRoute: StoreLayoutIndexRoute,
  StoreLayoutAdminFeatureAnnouncementsRoute:
    StoreLayoutAdminFeatureAnnouncementsRoute,
  StoreLayoutAdminPaymentMethodsRoute: StoreLayoutAdminPaymentMethodsRoute,
  StoreLayoutAdminShippingMethodsRoute: StoreLayoutAdminShippingMethodsRoute,
  StoreLayoutProductsAddRoute: StoreLayoutProductsAddRoute,
  StoreLayoutSettingsApiRoute: StoreLayoutSettingsApiRoute,
  StoreLayoutSettingsGeneralRoute: StoreLayoutSettingsGeneralRoute,
  StoreLayoutSettingsPaymentRoute: StoreLayoutSettingsPaymentRoute,
  StoreLayoutSettingsSeoRoute: StoreLayoutSettingsSeoRoute,
  StoreLayoutSettingsShippingRoute: StoreLayoutSettingsShippingRoute,
  StoreLayoutSettingsTeamRoute: StoreLayoutSettingsTeamRoute,
  StoreLayoutAdminFeatureAnnouncementsNewRoute:
    StoreLayoutAdminFeatureAnnouncementsNewRoute,
}

const StoreLayoutRouteWithChildren = StoreLayoutRoute._addFileChildren(
  StoreLayoutRouteChildren,
)

interface AuthAuthLayoutRouteChildren {
  AuthAuthLayoutForgotPasswordRoute: typeof AuthAuthLayoutForgotPasswordRoute
  AuthAuthLayoutResetPasswordRoute: typeof AuthAuthLayoutResetPasswordRoute
  AuthAuthLayoutSigninRoute: typeof AuthAuthLayoutSigninRoute
}

const AuthAuthLayoutRouteChildren: AuthAuthLayoutRouteChildren = {
  AuthAuthLayoutForgotPasswordRoute: AuthAuthLayoutForgotPasswordRoute,
  AuthAuthLayoutResetPasswordRoute: AuthAuthLayoutResetPasswordRoute,
  AuthAuthLayoutSigninRoute: AuthAuthLayoutSigninRoute,
}

const AuthAuthLayoutRouteWithChildren = AuthAuthLayoutRoute._addFileChildren(
  AuthAuthLayoutRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  StoreLayoutRoute: StoreLayoutRouteWithChildren,
  AuthAuthLayoutRoute: AuthAuthLayoutRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
